export default {
  // 申請入口
  apply: {
    title: 'プリペイド会員申請',
    button: 'プリペイド会員申請',
    viewLedger: 'プリペイド帳簿',
  },

  // 服務條款
  terms: {
    title: 'プリペイド会員サービス規約',
    subtitle: '以下の規約をよくお読みいただき、同意の上お申し込みください',
    agree: '上記の規約を読み、同意します',
    continue: '申請を続ける',
    back: '戻る',
    content: {
      section1: {
        title: '一、サービス説明',
        items: [
          'プリペイド会員は前払い制度です。お客様は事前にチャージしてからレンタルにご利用いただけます。',
          'チャージ金額は「実体金額」と「ボーナス金額」の2つに分かれます。',
          '実体金額はお客様が実際にお支払いいただいた金額で、領収書を発行できます。ボーナス金額はプラットフォームからの贈呈で、払い戻し不可です。',
        ],
      },
      section2: {
        title: '二、チャージ規則',
        items: [
          'チャージプランはプラットフォームが設定し、お客様は適切なプランを選択して申請できます。',
          '申請後は総店長の承認が必要で、現場で支払いを完了した後に開通します。',
          'チャージ金額は支払い完了後、すぐにお客様のプリペイドアカウントに入金されます。',
        ],
      },
      section3: {
        title: '三、使用規則',
        items: [
          '注文確認後、システムは自動的にプリペイドアカウントから扣款します。',
          '扣款順序：優先的に実体金額を扣除し、不足時はボーナス金額を扣除します。',
          '実体金額の消費部分は領収書を発行し、ボーナス金額の消費部分は領収書を発行しません。',
          'プリペイド残高が NT$ 3,000 未満になると、システムはチャージを促します。',
        ],
      },
      section4: {
        title: '四、払い戻し規則',
        items: [
          '実体金額は払い戻しが可能ですが、使用済みのボーナス金額に対応する実体金額を差し引く必要があります。',
          'ボーナス金額は払い戻し不可、譲渡不可です。',
          'プリペイド会員資格を解除する際、実体金額がゼロであることを確認する必要があります。',
        ],
      },
      section5: {
        title: '五、その他注意事項',
        items: [
          'チャージ金額は他の顧客に譲渡できません。',
          'プラットフォームはチャージプランを変更する権利を保有しますが、既にチャージされた金額には影響しません。',
          'ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。',
        ],
      },
    },
  },

  // 方案紹介
  plans: {
    title: 'チャージプランを選択',
    subtitle: 'お客様に適したチャージプランを選択し、より多くの特典をお楽しみください',
    realAmount: 'チャージ金額',
    bonusAmount: 'ボーナス金額',
    totalAmount: '実得金額',
    bonusRate: 'ボーナス率',
    select: 'このプランを選択',
    selected: '選択済み',
    popular: '人気',
    recommended: 'おすすめ',
  },

  // 申請フォーム
  application: {
    title: '申請情報の確認',
    subtitle: '申請情報をご確認ください。提出後は審査プロセスに入ります',
    selectedPlan: '選択したプラン',
    customerInfo: '顧客情報',
    name: '氏名',
    email: 'メール',
    phone: '電話',
    notes: '備考（任意）',
    notesPlaceholder: '特別な要望がある場合は、こちらにご記入ください...',
    agreeTerms: 'サービス規約を読み、同意します',
    submit: '申請を提出',
    submitting: '提出中...',
    back: '戻る',
    success: '申請が正常に提出されました！',
    successMessage: '申請が提出されました。管理者の審査通知をお待ちください。審査通過後、現場で支払いを完了してください。',
    error: '申請失敗',
    errorMessage: '申請の提出中にエラーが発生しました。後でもう一度お試しください。',
  },

  // 申請ステータス
  status: {
    pending: '審査中',
    approved: '承認済み',
    rejected: '却下',
    paid: '支払い済み',
    cancelled: 'キャンセル',
    pendingDesc: '申請は審査中です。しばらくお待ちください',
    approvedDesc: '申請が承認されました。現場で支払いを完了してください',
    rejectedDesc: '申請は承認されませんでした',
    paidDesc: '支払い完了、プリペイドアカウントが開通しました',
    cancelledDesc: '申請がキャンセルされました',
  },

  // 申請確認
  myApplication: {
    title: '私の申請',
    noApplication: '申請記録がありません',
    appliedAt: '申請時間',
    reviewedAt: '審査時間',
    paymentAt: '支払い時間',
    plan: '申請プラン',
    status: '申請ステータス',
    notes: '備考',
    rejectionReason: '却下理由',
    viewDetails: '詳細を見る',
  },

  // プリペイド帳簿
  ledger: {
    title: 'プリペイド帳簿',
    subtitle: 'プリペイド残高と取引記録を確認',
    accountBalance: 'アカウント残高',   // ← 重複キーを回避
    realBalance: '実体金額',
    bonusBalance: 'ボーナス金額',
    totalBalance: '総残高',
    statistics: '統計情報',
    totalDeposited: '累計チャージ',
    totalBonus: '累計ボーナス',
    totalSpent: '累計消費',
    lowBalanceWarning: '残高不足',
    lowBalanceMessage: 'プリペイド残高が NT$ 3,000 未満です。早めにチャージすることをお勧めします。',
    recharge: '今すぐチャージ',
    transactions: '取引記録',
    noTransactions: '取引記録がありません',
    date: '日付',
    type: 'タイプ',
    amount: '金額',
    balance: '残高',   // 表示用カラム名
    description: '説明',
    viewOrder: '注文を見る',
    deposit: 'チャージ',
    deduct: '扣款',
    refund: '返金',
    bonus: 'ボーナス',
    adjustment: '調整',
  },

  // 共通
  common: {
    loading: '読み込み中...',
    error: 'エラーが発生しました',
    retry: '再試行',
    close: '閉じる',
    confirm: '確認',
    cancel: 'キャンセル',
    save: '保存',
    edit: '編集',
    delete: '削除',
    back: '戻る',
    next: '次へ',
    previous: '前へ',
    submit: '送信',
    currency: 'NT$',
  },
};